export default __webpack_public_path__ + "static/media/other-providers.b49a2537.png";